import React from "react";
import DataGrid from "react-data-grid";

import db from "../../table.json";

import "./styles.css";

import tabela from "../../assets/tabelaTeste.png";

const columns = [
  { key: "id", name: "ID" },
  { key: "name", name: "Name" },
  { key: "type", name: "Type" },
  { key: "language", name: "Language" },
];

const rows = [
  { id: 0, title: "row1", count: 20 },
  { id: 1, title: "row1", count: 40 },
  { id: 2, title: "row1", count: 60 },
];

export default function DataGridRapicare() {
  return (
    <div className="wrapper">
      <div
        style={{
          width: "100%",
          marginTop: 20,
          marginRight: 10,
          marginLeft: 10,
        }}
      >
        <DataGrid
          columns={columns}
          rows={db.map((item) => item)}
          rowGetter={(i) => rows[i]}
          rowsCount={3}
          minHeight={150}
        />
      </div>
      <div>
        <img src={tabela} style={{ width: "100%", margin: 20 }} />
      </div>
    </div>
  );
}
